export const lessonTypeChipClass: Record<string, string> = {
  ltid_MiniAchievableResult: 'bg-highlight-bisque',
  ltid_AchievableResults: 'bg-highlight-linen',
  ltid_Test: 'bg-highlight-lightblue',
  ltid_FirstSemesterAchievmentRecords: 'bg-highlight-thistle',
  ltid_SecoundSemesterAchievmentRecords: 'bg-highlight-thistle',
  ltid_FirstSemester: 'bg-highlight-silver',
  ltid_SecoundSemester: 'bg-highlight-silver',
  ltid_FirstMidSemester: 'bg-highlight-yellow',
  ltid_SecoundMidSemester: 'bg-highlight-yellow',
  ltid_Diagnostic: 'bg-highlight-aqua',
  ltid_StateExam: 'bg-highlight-orange',
  ltid_Year: 'bg-highlight-lime',
  ltid_AfterTest: 'bg-highlight-violet',
  ltid_EndEvaluationInDiscipline: 'bg-highlight-khaki',
  ltid_Lesson: 'bg-highlight-gray',
  ltid_HomeTask: 'bg-highlight-gray',
  ltid_DisciplineRecord: 'bg-highlight-gray',
  ltid_None: 'bg-highlight-mint',
};

const DEFAULT_CHIP_CLASS = 'bg-highlight-mint';

export const getLessonTypeChipClass = (lessonTypeId: string): string =>
  lessonTypeChipClass[lessonTypeId] ?? DEFAULT_CHIP_CLASS;
